import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Check } from '@qaroni-app/check/types/check';
import { CheckHistoryApiObject } from '@qaroni-app/check/types/check-history-response';
import { CheckRegisterApiObject } from '@qaroni-app/check/types/check-register-response';
import { CheckReportApiObject } from '@qaroni-app/check/types/check-report-response';
import { Month } from '@qaroni-app/check/types/period';
import { ApiQWorkardsEnv } from '@qaroni-core/config/apis/api-qworkards/api-qworkards.config';

@Injectable({
  providedIn: 'root',
})
export class ScheduleCheckHttpService {
  private http = inject(HttpClient);

  public registerCheckFromCompany$(
    companyID: number,
    employeeID: number,
    check: Check
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/journeys`;
    return this.http.post<CheckRegisterApiObject>(url, check, {
      observe: 'response',
    });
  }

  public updateCheckFromCompany$(
    companyID: number,
    employeeID: number,
    checkID: number,
    check: Check
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/${checkID}/journeys`;
    return this.http.patch<CheckRegisterApiObject>(url, check, {
      observe: 'response',
    });
  }

  public deleteCheckFromCompany$(
    companyID: number,
    employeeID: number,
    checkID: number
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/${checkID}`;
    return this.http.delete<CheckRegisterApiObject>(url, {
      observe: 'response',
    });
  }

  public sendChecksReport$(
    companyID: number,
    employeeID: number,
    month: Month
  ) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/pdf`;
    return this.http.patch<CheckReportApiObject>(url, month, {
      observe: 'response',
    });
  }

  public checkHistory$(companyID: number, employeeID: number, checkID: number) {
    const url = `${ApiQWorkardsEnv.baseUrl}/companies/${companyID}/employees/${employeeID}/checks/${checkID}/histories`;
    return this.http.get<CheckHistoryApiObject>(url, { observe: 'response' });
  }
}
